import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * @param [queryParams] {object}
 * @param [queryParams.org] {string[]}
 * @param [queryParams.type] {string[]}
 * @param [queryParams.status] {string[]}
 * @param [queryParams.code] {string[]}
 * @param [queryParams.overlapsDateRangeFrom] {Date|string|number}
 * @param [queryParams.overlapsDateRangeTo] {Date|string|number}
 */
export function getPmLeaves(queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/peopleLeaves/pm?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param [queryParams] {object}
 * @param [queryParams.org] {string[]}
 * @param [queryParams.type] {string[]}
 * @param [queryParams.status] {string[]}
 * @param [queryParams.code] {string[]}
 * @param [queryParams.overlapsDateRangeFrom] {Date|string|number}
 * @param [queryParams.overlapsDateRangeTo] {Date|string|number}
 */
export function getMyLeaves(queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/peopleLeaves/my?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param orgId {string}
 * @param [queryParams] {object}
 * @param [queryParams.person] {string[]}
 * @param [queryParams.type] {string[]}
 * @param [queryParams.status] {string[]}
 * @param [queryParams.code] {string[]}
 * @param [queryParams.overlapsDateRangeFrom] {Date|string|number}
 * @param [queryParams.overlapsDateRangeTo] {Date|string|number}
 */
export function getOrgLeaves(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/peopleLeaves?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getOrgLeavesLean(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/peopleLeaves/ultra-lean?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getOrgLeavesOrgTimeLean(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/peopleLeaves/org-time-lean?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * My leave balances, worked out on the server: { org, years, balances: { [year]: { [leaveCodeId]: {...} } } }
 * @param orgId {string}
 * @param years {number[]}
 */
export function getMyLeaveBalances(orgId, years, signal) {
    const qs = queryString.stringify({ org: orgId, years: years.join(",") })

    return api
        .get(`/v2/peopleLeaves/my/balances?${qs}`, { signal })
        .then((res) => res.data)
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * Leave balances of up to 500 people: { balances: { [refId]: { [year]: { [leaveCodeId]: {...} } } } }
 * @param orgId {string}
 * @param body {object}
 * @param body.persons {string[]}
 * @param body.years {number[]}
 * @param [body.codes] {string[]}
 */
export function getOrgLeaveBalances(orgId, body, signal) {
    return api
        .post(`/v2/orgs/${orgId}/peopleLeaves/balances`, body, { signal })
        .then((res) => res.data)
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
